import { useState } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";

function Layout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      <div className="d-flex h-100 position-relative">

        <Sidebar
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          user={user}
        />

        <div
          className="flex-grow-1 d-flex flex-column"
          style={{
            backgroundColor: "#f4f6f9",
            transition: "margin-left 0.3s ease",
            marginLeft:
              window.innerWidth > 768
                ? collapsed
                  ? "80px"
                  : "250px"
                : "0px"
          }}
        >
          <div className="d-flex align-items-center justify-content-between p-3 bg-white shadow-sm">

            <div className="d-flex align-items-center">
              <button
                className="btn btn-outline-dark d-md-none me-2"
                onClick={() => setMobileOpen(true)}
              >
                ☰
              </button>

              <button
                className="btn btn-outline-dark d-none d-md-block"
                onClick={() => setCollapsed(!collapsed)}
              >
                {collapsed ? "→" : "←"}
              </button>

              <h5 className="mb-0 ms-3">Star Laser ERP</h5>
            </div>

            <div className="d-flex align-items-center">
              <span className="me-3 fw-semibold">
                {user?.username}
              </span>
              <button
                className="btn btn-danger btn-sm"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>

          </div>

          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "24px"
            }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Layout;